import {initTomSelectInput} from "../../helpers/inputs/tom-select/tom-select";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import {loading, stopLoading} from "../../helpers/loading";
import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import createElement from "../../helpers/createElement";
import {createReplaceableElement} from "../../helpers/replaceableElement";
import {createModal} from "../../helpers/modal";
import {initScriptForm} from "./scripts/initScriptForm";
import {createSendToThirdPartyCompanyModal} from "./sendToThirdPartyCompanyModal";
import _ from "lodash";
import {initProcessingLog} from "../../common/voe-orders/initProcessingLog";

function initAgentsOrdersProcess() {
	// noinspection JSUnusedLocalSymbols
	const SOURCE_RESPONDER_SCRIPT_SECTION = 'source-responder';
	const VOE_SCRIPT_SECTION = 'voe-fulfillment';

	// Endpoints
	const finishVoeAttemptEndpoint = window["routes/agent.voe-orders.finish-voe-attempt"];
	const getComponentsEndpoint = window["routes/agent.voe-orders.get-process-view-components"];

	// Static Elements
	const agentButtonsContainer = document.querySelector('.agent-buttons');
	const voeOrderSection = document.querySelector('.voe-order-section');
	const companySection = document.querySelector('.company-section');

	// Init Components
	const orderComponent = createReplaceableElement({
		element: document.querySelector('.voe-order-card'),
		init: function () {
			const backToCompanyButton = this.element.querySelector('.back-to-company-view-button');
			if (backToCompanyButton) {
				backToCompanyButton.addEventListener('click', displayCompanySection);
			}
		}
	});
	const statusComponent = createReplaceableElement({
		element: document.querySelector('.voe-status-card'),
		init: function () {
			const voeAttemptStatusSelect = this.element.querySelector('select[name="status_key"]');
			const voeAttemptStatusTomSelectInstance = initTomSelectInput(voeAttemptStatusSelect, {
				render: {
					option: (data) => {
						const selectedTextOrNothing = data.$option.dataset.lastStatus ?
							' - <span class="badge badge-primary"><span class="mono">LAST OUTCOME</span></span>' : '';
						return createElement(`<div>${data.text}${selectedTextOrNothing}</div>`);
					},
				},
				// Make dropdown parent the body so its not hidden by the inner container scrolling
				dropdownParent: 'body',
				onDropdownOpen: () => {
					// Reposition on first open so it appears properly
					voeAttemptStatusTomSelectInstance.positionDropdown();
				}
			})

			// Display next call schedule inputs when required
			voeAttemptStatusSelect.addEventListener('change', () => {
				this.renderNextCallScheduleContainer();
			})

			// Initial call to render next call schedule container if it was previous outcome
			this.renderNextCallScheduleContainer();

			// Init log container
			initProcessingLog(this.element);

			// Init finish VOE attempt button
			this.element.querySelector('.finish-voe-attempt-button')
				.addEventListener('click', handleFinishVoeAttemptRequest);
		},
		// Displays or hides next call container based on selected outcome
		renderNextCallScheduleContainer() {
			const nextCallScheduleContainer = this.element.querySelector('.next-call-schedule-container');
			const voeAttemptStatusSelect = this.element.querySelector('select[name="status_key"]');

			const displayNextCallScheduleContainer =
				voeAttemptStatusSelect.value === 'answered-call-order-placed-in-call-queue-for-specific-time-call-back';

			if (nextCallScheduleContainer) {
				if (displayNextCallScheduleContainer) {
					nextCallScheduleContainer.classList.remove('d-none');
				} else {
					nextCallScheduleContainer.classList.add('d-none');
				}
			}
		}
	});
	const scriptComponent = createReplaceableElement({
		element: document.querySelector('.voe-script-card'),
		init: function () {
			/**
			 * Setup buttons
			 */

			// Save progress button
			this.element.querySelectorAll('.save-progress-button')
				.forEach(button => {
					button.addEventListener('click', handleSaveProgressRequest)
				})

			initScriptForm(this.element);
		},
	});

	// Init modals
	const callNumberModal = createModal({
		modalContainer: document.querySelector('.call-number-modal'),
		init() {
			// Make modal normal sized
			this.modalContainer.querySelector('.modal-dialog').classList.remove('modal-lg');

			// Make modal height auto sized
			const body = this.modalContainer.querySelector('.modal-body');

			body.style.minHeight = 'unset';
			body.style.height = 'auto';
		}
	})

	const sendEmailModal = createModal({
		modalContainer: document.querySelector('.send-email-modal'),
		init() {
			// Make modal normal sized
			this.modalContainer.querySelector('.modal-dialog').classList.remove('modal-lg');

			// Make modal height auto sized
			const body = this.modalContainer.querySelector('.modal-body');

			body.style.minHeight = 'unset';
			body.style.height = 'auto';

			// Add event listener to buttons
			this.modalContainer.querySelectorAll('.send-email-button').forEach(button => {
				button.onclick = () => {
					handleSendVoeRequestEmailRequest(button)
				};
			});

			[
				'source_responder_work_email',
				'source_responder_personal_email',
			].forEach(emailField => {
				const input = this.modalContainer.querySelector(`input[name="${emailField}"]`)
				input.addEventListener('keyup', _.debounce(() => {
					this.enableEmailButton(input);
				}, 64, {trailing: true}));
			})
		},
		enableEmailButton(element) {
			const relatedButton = element.closest('.row')
				.querySelector('.send-email-button');
			relatedButton.disabled = !element.value.trim();
		}
	})

	const sendToThirdPartyModal = createSendToThirdPartyCompanyModal();

	// Init buttons
	const callNumberButton = document.querySelector('.call-number-button');
	if (callNumberButton) {
		callNumberButton.addEventListener('click', displayCallModal);
	}

	const sendEmailButton = document.querySelector('.send-email-button');
	if (sendEmailButton) {
		sendEmailButton.addEventListener('click', displayEmailModal);
	}

	const sendToThirdPartyButton = document.querySelector('.send-to-3rd-party-button');
	if (sendToThirdPartyButton) {
		sendToThirdPartyButton.onclick = () => sendToThirdPartyModal.display();
	}

	const sendBackToResearchersButton = document.querySelector('.send-back-to-researchers-button');
	if (sendBackToResearchersButton) {
		sendBackToResearchersButton.onclick = () => {
			swalConfirm({
				title: 'Are you sure you want to send this back to the research queue?'
			}).then(response => {
				if (response.isConfirmed) {
					loading();

					Axios.post(window['routes/agent.voe-orders.send-back-to-researchers'])
						.then(handleAjaxSuccess)
						.catch(handleAjaxError)
						.then(stopLoading);
				}
			})
		}
	}

	const sourceResponderFields = [
		// Source responder fields
		'source_responder_first_name',
		'source_responder_last_name',
		'source_responder_position',
		'source_responder_telephone',
		'source_responder_cellphone',
		'source_responder_work_email',
		'source_responder_personal_email',
		'source_responder_source_type'
	]

	const voeResultFields = [

		// Standard script fields
		'voe_result_origin_key',
		'employer_division',
		'employment_status_key',
		'job_title',
		'most_recent_start_date',
		'most_recent_end_date',
		'original_start_date',
		'years_with_employer',
		'months_with_employer',
		'reason_for_leaving',
		'compensation',
		'other_information',
	];

	// Custom questions script fields
	const voeCustomQuestionsFields = window['custom_questions_fields_names'];

	/**
	 * Methods
	 */

	function handleFinishVoeAttemptRequest() {
		const data = getInputsByName(statusComponent.element, [
			'notes',
			'status_key',
			'next_voe_attempt_scheduled_hours',
			'next_voe_attempt_scheduled_minutes',
		]);

		// Also send the current attempt progress
		const voeResultData = getInputsByName(scriptComponent.element, voeResultFields);
		const sourceResponderData = getInputsByName(scriptComponent.element, sourceResponderFields);

		data.voeResultData = voeResultData;
		data.sourceResponderData = sourceResponderData;

		if (voeCustomQuestionsFields) {
			data.voeCustomQuestionsData = getInputsByName(scriptComponent.element, voeCustomQuestionsFields);
		}

		clearFeedbacksByName(statusComponent.element);
		clearFeedbacksByName(scriptComponent.element);

		loading();

		Axios.post(finishVoeAttemptEndpoint, data)
			.then(handleAjaxSuccess)
			.catch(e => {
				// TODO: 	Make sure there are no conflicts with naming when resolving
				// 			inputs for validation errors, may want to do some manual container
				// 			toggle based on returned fields
				handleAjaxError(e, null)

				displayScriptSectionWithErrors();
			})
			.finally(stopLoading)
	}

	function handleSaveProgressRequest() {
		const voeResultData = getInputsByName(scriptComponent.element, voeResultFields);
		const sourceResponderData = getInputsByName(scriptComponent.element, sourceResponderFields);

		clearFeedbacksByName(scriptComponent.element);

		const data = {
			voeResultData,
			sourceResponderData,
		}

		if (voeCustomQuestionsFields) {
			data.voeCustomQuestionsData = getInputsByName(scriptComponent.element, voeCustomQuestionsFields);
		}

		loading();

		Axios.post(window['routes/agent.voe-orders.save-voe-attempt-progress'], data)
			.then(() => {
				// Reload order in place
				const componentsToUpdate = {
					orderComponent: true,
				}

				const currentActiveScriptSection = getVisibleScriptSection();

				// Only update the script component if we are not on the VOE section
				if (currentActiveScriptSection !== VOE_SCRIPT_SECTION) {
					componentsToUpdate.scriptComponent = true;
				}

				updateComponents(componentsToUpdate).then();
			})
			.catch(e => {
				handleAjaxError(e, scriptComponent.element)

				displayScriptSectionWithErrors();
			})
			.finally(stopLoading)
	}

	/**
	 * Returns the currently visible script section
	 */
	function getVisibleScriptSection() {
		const visibleScriptElement = scriptComponent.element.querySelector('.scripts-wrapper .tab-pane.active');

		if (visibleScriptElement) {
			return visibleScriptElement.dataset.scriptSectionName;
		}
		return '';
	}

	/**
	 * Displays the script section that contains errors, if any
	 */
	function displayScriptSectionWithErrors() {
		console.log('CHECKING');
		// Because we don't know where the errors where displayed, we will
		// check for the first .invalid-feedback and display that section
		const errorFeedback = scriptComponent.element.querySelector('.invalid-feedback.d-block');
		if (errorFeedback) {
			// Retrieve section element
			const scriptSection = errorFeedback.closest('.tab-pane').dataset.scriptSectionName;

			// Display related tab
			const tab = scriptComponent.element
				.querySelector(
					`.nav-link[data-script-section-name="${scriptSection}"]`
				);

			$(tab).tab('show');
		}
	}

	/**
	 * Partially updates components in place
	 *
	 * @param {object} requestedComponents
	 * @param {boolean} [requestedComponents.orderComponent] Refresh order component
	 * @param {boolean} [requestedComponents.scriptComponent] Refresh scripts section component
	 */
	function updateComponents(requestedComponents = {}) {
		const requestedComponentsKeys = Object.keys(requestedComponents);

		const viewComponents = {
			orderComponent,
			statusComponent,
			scriptComponent,
		}

		// Set loading overlay on requested components
		requestedComponentsKeys.forEach(component => {
			viewComponents[component].startLoading();
		})

		return Axios.post(getComponentsEndpoint, {
			components: viewComponents,
			// Preserve currently visible section
			scriptToDisplay: getVisibleScriptSection(),
		})
			.then(response => {
				const updatedComponents = response.data;
				requestedComponentsKeys.forEach(component => {
					// Create dom element
					const componentElement = createElement(updatedComponents[component]);

					// Replace
					viewComponents[component].replace(componentElement);
				})
			})
			.catch(error => {
				handleAjaxError(error);
				// Clear overlays on requested components on error
				requestedComponentsKeys.forEach(component => {
					viewComponents[component].stopLoading();
				})
			})
	}

	// We expose updateComponents() so it can be called from the researcher view when needed
	window.agents_process_view_update_components = updateComponents;

	function displayCallModal() {
		// Update modal status
		const modalContainer = callNumberModal.modalContainer;

		// Disable buttons
		modalContainer.querySelectorAll('.start-call-number-button').forEach(button => {
			button.disabled = true;
		});

		const companyNumberElement = modalContainer.querySelector('[data-company-number="true"]');
		const sourceResponderDirectNumberElement = modalContainer.querySelector('[data-source-responder-direct-number="true"]');
		const sourceResponderCellphoneElement = modalContainer.querySelector('[data-source-responder-cellphone="true"]');

		// Clear elements
		[
			companyNumberElement,
			sourceResponderDirectNumberElement,
			sourceResponderCellphoneElement
		].forEach(element => {
			element.value = 'None';
		})

		// Helper function
		function enableCall(modalElement, savedElement) {
			// Set value
			modalElement.value = savedElement.innerText;

			// Enable Calling
			const relatedButton = $(modalElement).closest('.row')[0]
				.querySelector('.start-call-number-button');

			// Enable button
			relatedButton.disabled = false;

			// Set event on related button
			relatedButton.onclick = () => {
				// Close modal
				callNumberModal.hide();

				// Call number
				savedElement.click()
			};
		}

		// Retrieve numbers from saved form
		// Only use them if found as anchor tags
		const savedCompanyNumberElement = orderComponent.element
			.querySelector('a[data-company-phone="true"]');

		const savedSourceResponderDirectNumberElement = orderComponent.element
			.querySelector('a[data-source-responder-direct-phone="true"]');

		const savedSourceResponderCellphoneElement = orderComponent.element
			.querySelector('a[data-source-responder-cellphone="true"]');

		if (savedCompanyNumberElement) {
			enableCall(companyNumberElement, savedCompanyNumberElement);
		}

		if (savedSourceResponderDirectNumberElement) {
			enableCall(sourceResponderDirectNumberElement, savedSourceResponderDirectNumberElement);
		}

		if (savedSourceResponderCellphoneElement) {
			enableCall(sourceResponderCellphoneElement, savedSourceResponderCellphoneElement);
		}

		callNumberModal.display();
	}

	function displayEmailModal() {
		// Update modal status
		const modalContainer = sendEmailModal.modalContainer;

		// Disable buttons
		modalContainer.querySelectorAll('.send-email-button').forEach(button => {
			button.disabled = true;
		});

		const companyEmail = modalContainer.querySelector('[data-company-email]');
		const sourceResponderFirstName = modalContainer.querySelector('input[name="source_responder_first_name"]');
		const sourceResponderLastName = modalContainer.querySelector('input[name="source_responder_last_name"]');
		const sourceResponderWorkEmail = modalContainer.querySelector('input[name="source_responder_work_email"]');
		const sourceResponderPersonalEmail = modalContainer.querySelector('input[name="source_responder_personal_email"]');

		// Clear inputs
		[
			companyEmail,
		].forEach(element => {
			element.value = 'None';
		});
		[
			sourceResponderFirstName,
			sourceResponderLastName,
			sourceResponderWorkEmail,
			sourceResponderPersonalEmail,
		].forEach(element => {
			element.value = '';
		})

		clearFeedbacksByName(sendEmailModal.modalContainer);

		// Retrieve emails from saved form
		const savedCompanyEmail = orderComponent.element
			.querySelector('[data-company-email="true"]');

		const savedSourceResponderFirstName = scriptComponent.element
			.querySelector('input[name="source_responder_first_name"]');
		const savedSourceResponderLastName = scriptComponent.element
			.querySelector('input[name="source_responder_last_name"]');

		const savedSourceResponderWorkEmail = orderComponent.element
			.querySelector('[data-sourcer-responder-work-email="true"]');

		const savedSourceResponderPersonalEmail = orderComponent.element
			.querySelector('[data-sourcer-responder-personal-email="true"]');

		if (savedCompanyEmail && savedCompanyEmail.value !== 'None') {
			companyEmail.value = savedCompanyEmail.value
			sendEmailModal.enableEmailButton(companyEmail);
		}


		if (savedSourceResponderFirstName) {
			sourceResponderFirstName.value = savedSourceResponderFirstName.value
		}

		if (savedSourceResponderLastName) {
			sourceResponderLastName.value = savedSourceResponderLastName.value
		}

		if (savedSourceResponderWorkEmail && savedSourceResponderWorkEmail.value !== 'None') {
			sourceResponderWorkEmail.value = savedSourceResponderWorkEmail.value
			sendEmailModal.enableEmailButton(sourceResponderWorkEmail);
		}

		if (savedSourceResponderPersonalEmail && savedSourceResponderPersonalEmail.value !== 'None') {
			sourceResponderPersonalEmail.value = savedSourceResponderPersonalEmail.value
			sendEmailModal.enableEmailButton(sourceResponderPersonalEmail);
		}

		sendEmailModal.display();
	}

	/**
	 * @param {Element} button
	 */
	function handleSendVoeRequestEmailRequest(button) {
		const rowParent = $(button).closest('.row')[0];

		const email = rowParent.querySelector('input').value;


		// noinspection JSUnresolvedVariable
		const data = {
			email,
			addressed: button.dataset.addressed,
			sourceResponderData: getInputsByName(sendEmailModal.modalContainer, sourceResponderFields),
		}

		clearFeedbacksByName(sendEmailModal.modalContainer);

		loading();

		Axios.post(window['routes/agent.voe-orders.send-voe-request-email'], data)
			.then(response => {
				handleAjaxSuccess(response, () => {
					sendEmailModal.hide();
					updateComponents({
						orderComponent: true,
						scriptComponent: true,
					}).then()
				})
			})
			.catch(e => {
				handleAjaxError(e, sendEmailModal.modalContainer);
			})
			.finally(stopLoading)
	}

	function displayCompanySection() {
		// Hide agent buttons
		agentButtonsContainer.classList.add('opacity-0', 'pointer-events-none');

		// Hide agent section
		voeOrderSection.classList.add('d-none');

		// Display company section
		companySection.classList.remove('d-none');

		window.researcher_process_view_companies_grid.columnApi.autoSizeAllColumns();
		window.researcher_process_view_companies_grid._refresh();
	}
}

export {
	initAgentsOrdersProcess
};
